import { Col as AntdCol, type ColProps as AntdColProps } from 'antd'
import { forwardRef } from 'react'
import styles from './styles.module.scss'

export interface ColProps extends AntdColProps {
  avoidGutterHorizontalScroll?: boolean
}

export const COL_TEST_ID = 'col-test-id'

export const Col = forwardRef<HTMLDivElement, ColProps>(
  ({ avoidGutterHorizontalScroll = true, className, ...props }, ref) => {
    const defaultClassName = className ? [className] : []
    const gutterClassname = avoidGutterHorizontalScroll ? [styles.avoidGutterHorizontalScroll] : []

    const classNames = [...defaultClassName, ...gutterClassname].join(' ')

    return <AntdCol ref={ref} className={classNames} data-testid={COL_TEST_ID} {...props} />
  },
)
Col.displayName = 'Col'
